import React, { Component, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
  errorInfo?: React.ErrorInfo;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('Error caught by boundary:', error);
    console.error('Error info:', errorInfo);

    this.setState({
      error,
      errorInfo
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-gray-900 text-white flex items-center justify-center p-4">
          <div className="max-w-md w-full text-center">
            <div className="card">
              <h1 className="text-2xl font-bold text-red-400 mb-4">
                שגיאת מערכת
              </h1>
              <p className="text-gray-300 mb-6">
                אירעה שגיאה לא צפויה במערכת. אנא טען מחדש את הדף.
              </p>
              <button
                onClick={() => window.location.reload()}
                className="btn-primary w-full mb-4"
              >
                טען מחדש
              </button>

              {process.env.NODE_ENV === 'development' && (
                <details className="text-left text-sm text-gray-400 mt-4">
                  <summary className="cursor-pointer mb-2">פרטי השגיאה</summary>
                  <pre className="bg-gray-950 p-2 rounded text-xs overflow-auto">
                    {this.state.error?.toString()}
                    {'\n\n'}
                    {this.state.errorInfo?.componentStack}
                  </pre>
                </details>
              )}
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}